<template>
    <div class="text-field">
        <label class="text-field-label" v-bind:style="{fontWeight: fontWeight }">{{ labelPartOne }} <span style="white-space:nowrap;">{{ labelPartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip">{{ tooltipText }}<div class="arrow-down"></div></span></span></span></label>
        <div class="input-group mb-3 input-group-with-lookup">
            <suggestions ref="property-suburb-autocomplete" v-model="value" class="text-field-suggestions" :options="{debounce: 500}" :onInputChange="findSuburb" :onItemSelected="selectOption"></suggestions>
        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    import _ from 'lodash';
    import Suggestions from "v-suggestions/src/Suggestions";

    export default {
        components: {Suggestions},
        name: "text-field",
        data () {
            return {
                activeTooltip: false,
                lookupList: [],
                selectedOption: false
            }
        },
        props: {
            name: String,
            value: String,
            placeholder: String,
            label: String,
            isBoldFont: Boolean,
            hasTooltip: Boolean
        },
        computed: {
            labelPartOne: function () {
                return this.label.substring(0, this.label.lastIndexOf(" ") + 1);
            },
            labelPartTwo: function () {
                return this.label.substring(this.label.lastIndexOf(" ") + 1);
            },
            fontWeight: function () {
                return this.isBoldFont ? 'bold' : 'normal';
            },
            tooltipText: function () {
                return "The Suburb and State the property is located";
            },
            displayValue: {
                get: function () {
                    return this.value;
                },
                set: function (newValue) {
                    if (this.selectedOption) {
                        this.value = newValue;
                    } else {
                        this.value = "";
                    }
                }
            }
        },
        methods: {

            findSuburb: function () {
                var suburbArr = this.value.split(", ");
                var suburb = suburbArr[0];

                var postCodeAndState;
                var postcode;
                var state;

                var lookupList = [];

                this.$emit('calc', this.value);

                if (suburbArr.length === 1) {
                    return new Promise( resolve => {
                        axios.get('https://secure.geonames.org/postalCodeSearchJSON?', {
                            params: {
                                username: 'cashflowcalculator',
                                country: 'AU',
                                placename_startsWith: suburb,
                                maxRows: 5
                            }
                        }).then(response => {

                            response.data.postalCodes.forEach(function (currentValue) {
                                lookupList.push(currentValue.placeName + ", " + currentValue.postalCode + " " + currentValue.adminCode1);
                            });

                        });
                        resolve(lookupList);
                    });
                } else if (suburbArr.length > 1 && this.value.split(", ")[1] != null && !isNaN(suburbArr[1].split(" ")[0])) {
                    postCodeAndState = suburbArr[1];
                    postcode = postCodeAndState.split(" ")[0];

                    return new Promise( resolve => {
                        axios.get('https://secure.geonames.org/postalCodeSearchJSON?', {
                            params: {
                                username: 'cashflowcalculator',
                                country: 'AU',
                                placename_startsWith: suburb,
                                postalcode_startsWith: postcode,
                                maxRows: 5
                            }
                        }).then(response => {

                            response.data.postalCodes.forEach(function (currentValue) {
                                lookupList.push(currentValue.placeName + ", " + currentValue.postalCode + " " + currentValue.adminCode1);
                            });
                        });
                        resolve(lookupList);
                    });
                } else if (suburbArr.length > 1 && this.value.split(", ")[1] != null && isNaN(suburbArr[1].split(" ")[0])) {
                    postCodeAndState = suburbArr[1];
                    state = postCodeAndState.split(" ")[1];

                    return new Promise( resolve => {
                        axios.get('https://secure.geonames.org/postalCodeSearchJSON?', {
                            params: {
                                username: 'cashflowcalculator',
                                country: 'AU',
                                placename_startsWith: suburb,
                                adminCode1: state,
                                maxRows: 5
                            }
                        }).then(response => {

                            response.data.postalCodes.forEach(function (currentValue) {
                                lookupList.push(currentValue.placeName + ", " + currentValue.postalCode + " " + currentValue.adminCode1);
                            });
                        });
                        resolve(lookupList);
                    });
                } else if (suburbArr.length > 1 && postCodeAndState.length > 1) {
                    postCodeAndState = suburbArr[1];
                    postcode = postCodeAndState.split(" ")[0];
                    state = postCodeAndState.split(" ")[1];

                    return new Promise( resolve => {
                        axios.get('https://secure.geonames.org/postalCodeSearchJSON?', {
                            params: {
                                username: 'cashflowcalculator',
                                country: 'AU',
                                placename: suburb,
                                postalcode: postcode,
                                adminCode1: state,
                                maxRows: 5
                            }
                        }).then(response => {

                            response.data.postalCodes.forEach(function (currentValue) {
                                lookupList.push(currentValue.placeName + ", " + currentValue.postalCode + " " + currentValue.adminCode1);
                            });
                        });
                        resolve(lookupList);
                    });
                }
            },
            selectOption: function (lookupOption) {
                this.value = lookupOption;
                this.$emit('calc', this.value);
            },
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            },
            onChange: function () {
                this.$refs['property-suburb-autocomplete'].value = "";
            },
            validateValue: function () {
                var suburbArr = this.value.split(", ");
                var suburb = suburbArr[0];
                var postCodeAndState = suburbArr[1];
                var postCode;
                var state;

                if (postCodeAndState !== undefined) {
                    postCode = postCodeAndState.split(" ")[0];
                    state = postCodeAndState.split(" ")[1];
                }

                if (!(suburb !== undefined && postCode !== undefined && state !== undefined)) {
                    this.value = '';
                    this.$refs['property-suburb-autocomplete'].value = "";
                    this.$refs['property-suburb-autocomplete'].query = "";
                }
            }
        },
        mounted () {
            var lookupOptions = document.getElementsByClassName("item");

            for (var i = 0; i < lookupOptions.length; i++) {
                lookupOptions[i].addEventListener('touch', function (e) {
                    this.$emit('calc', this.value);
                })
            }

            var textField = document.getElementsByClassName('input')[0];
            textField.addEventListener('focus', function () {
                setTimeout(function() {
                    textField.setSelectionRange(999999, 999999);
                }, 0);
            });

            let $vm = this;
            textField.addEventListener('change', function () {
                if (!this.selectedOption) {
                    this.value = '';
                    $vm.$refs['property-suburb-autocomplete'].value = "";
                    $vm.$refs['property-suburb-autocomplete'].query = "";
                    setTimeout(function() {
                        $vm.$refs['property-suburb-autocomplete'].showItems = false;
                    }, 600);
                }
            })
        }
    }
</script>

<style>

    .text-field-label {
        float: left;
        font-size: 20px;
        color: #465978;
        width: 48% !important;
        margin-top: -7px;
        margin-bottom: 15px;
    }

    .input-group-with-lookup {
        width: 50%;
        margin-left: auto;
    }

    .text-field {
        width: 85%;
        margin: 0 auto;
    }

    .text-field-suggestions {
        width: 100% !important;
        text-align: right;
    }

    .text-field-suggestions .input {
         width: 100% !important;
         border: 1px solid #ced4da;
         border-radius: 4px !important;
         height: 38px !important;
         text-align: right !important;
         font-size: 20px !important;
         color: #495057 !important;
         padding-left: 5px !important;
         padding-right: 5px !important;
     }

    .text-field-suggestions .suggestions {
        top: 39px !important;
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;
        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -60px;
        left: 0px;
        background-color: #465978;
        height: 58px;
        width: 220px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        white-space: normal;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .not-entered-input {
        background-color: #ffcccc;
        border-width: 2px !important;
        border-color: #d9534f !important;
    }

    @media (min-width: 1024px) {
        .text-field {
            margin-bottom: 30px;
        }
    }

    @media (min-width: 768px) {
        .suggestions {
            max-height: 192px !important;
            overflow-x: hidden !important;
            overflow-y: auto !important;
            -webkit-overflow-scrolling:touch !important;
        }
    }

    @media (max-width: 435px) {

        .input-group-with-lookup {
            width: 50%;
            margin-top: 5px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/TextField.vue